import { Link, Navigate, useLocation } from "react-router-dom";
import { useWorkspace } from "../lib/WorkspaceContext";

export function SubscriptionConfirmation() {
  const { state } = useLocation();
  const { active } = useWorkspace();
  // Ordinary direct visits must not display a successful submission.
  if (typeof state?.requestId !== "string" || !state.requestId
    || state.workspaceId !== active?.workspace_id) {
    return <Navigate to="/plans" replace />;
  }

  return (
    <section className="plan-selection">
      <h1>Request received</h1>
      <div className="card">
        <h2>Thank you for choosing SiminoSocial</h2>
        <p>We have received your plan request. We will review it and send you payment instructions.</p>
        {state.emailStatus === "sent" ? (
          <p>A confirmation email has been sent to your contact email address.</p>
        ) : (
          <p className="notice">Your request is saved, but we could not send the confirmation email. You can still check its status in your profile.</p>
        )}
        <p className="muted">Nothing has been charged. Your plan will be applied once your payment is confirmed.</p>
        <div className="row">
          <Link className="btn primary" to="/profile">View request status</Link>
          <Link className="btn" to="/plans">Back to plans</Link>
        </div>
      </div>
    </section>
  );
}
